



















































import { defineComponent, reactive, toRefs } from '@vue/composition-api';

import { maps } from '@/data';

export default defineComponent({
  setup() {
    const state = reactive({
      selectedCampaign: maps[3]
    });

    return {
      ...toRefs(state),
      campaigns: maps
    };
  }
});
